import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
// Basic Components
import Button from 'screens/components/basic/Button';
import DialogHeader from 'screens/components/basic/DialogHeader';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';

class POSCloseOpenOrders extends Component {
    render() {
        const { t } = this.props; 
        return (
            <div>
                {(this.props.show) ?
                    <DialogInput
                        title={<DialogHeader text={this.props.title} classicClass="posDialogClassic" />}
                        modal={true}
                        open={this.props.show}
                        autoScrollBodyContent={true}
                        style={{ zIndex: '950' }}
                        actions={[
                            <Button
                                key={1}
                                type="CancelButton"
                                id="buttonCancel"
                                name="buttonCancel"
                                className="btn-space"
                                label={t('pos.closeOpenOrders.dropLater')}
                                onTouchTap={() => this.props.onCancel()} />,
                            <Button
                                key={2}
                                name="buttonConfirmCashIn"
                                label={t('common.confirm')}
                                className="btnNewBrandPOS"
                                primary={true}
                                onTouchTap={() => this.props.onComfirm()} />]}
                        contentStyle={{ width: '65%' }}>
                        <div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <h4>
                                        {this.props.message}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </DialogInput>
                    : ""}
            </div>
        )
    }
}

function mapStateToProps() {
    return {
    };
}

function mapDispatchToProps() {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSCloseOpenOrders))